/* import formatearNumero from "../../helpers/datos/formatearNumero"; */

export default function TablaIngresosMensual(/* { primavera1, primavera2, finalValues } */) {

    /* console.clear(); */
    /* let arr1d;
    const labels = ["Año", "Enero", "Febrero", "Marzo", "Abril", "Mayo",
        "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre", "Total"];
    let finalValue = finalValues[0] ?? Array(Math.abs(primavera1 - primavera2) + 1).fill(Array(12).fill(0));
    arr1d = [].concat(...finalValue);
    arr1d = arr1d.filter(value => arr1d.indexOf(value) % 13 !== 0); */

    return (
        <>
            {/* <div id="anual" className="tabcontent">
                <div className="contenedorMensual">

                    <div className="tituloMensual">Reporte Mensual: {Math.min(primavera1, primavera2)}-{Math.max(primavera1, primavera2)}</div>
                    <>
                        {labels.map(month => <div className="encabezadoMensual">{month}</div>)}
                        {[... new Set(finalValues)] &&
                            (finalValues.map(values =>
                                values.map(ingresos =>
                                    <>
                                        <div className="filaMensual">{ingresos[0]}</div>
                                        {ingresos.slice(1).map(value =>
                                            <div className="filaMensual" key={Math.floor(Math.random() * 1_000_000)}>${formatearNumero(value.toFixed(2))}</div>)}
                                        < div className="filaMensual" > ${formatearNumero(ingresos.slice(1).reduce((partialSum, a) => partialSum + a, 0).toFixed(2))}</div>
                                    </>
                                )
                            ))
                        }
                        <div className="totalMensual">Total $</div>

                        <div className="importeMensual">{formatearNumero([... new Set(arr1d)].reduce((partialSum, a) => partialSum + a, 0).toFixed(2))}</div>
                    </>
                </div>
            </div > */}
        </>
    );
}